/**
 * Page-retailers ESM entry point.
 *
 * Loaded by snippets/retailers.liquid itself, so it ships on every page that
 * renders the country select (page.retailers and the About page's Stockists).
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntryPageRetailers]
 */

import { log } from './log.js';
import './page-retailers.js';

log('[App] entry-page-retailers loaded');
